export default {
  namespaced: true,
  state: {
  },
  getters: {
    // 管理者かどうかを返す
    isManager(state, getters, rootState, rootGetters) {
      // 工事
      const construction = rootGetters['api/result/cloudConstructionInfo']
      if (!construction) return false

      // ログインユーザー
      const currentAccount = rootGetters['api/result/accountInfo']
      if (!currentAccount) return false

      // 工事のメンバーリスト
      const accountInfoList = construction.account_info_list
      // ログインユーザーの工事メンバー情報
      const member = accountInfoList.find(accountInfo => accountInfo.account_id === currentAccount.account_id);
      if (!member) return false

      // ログインユーザーが管理者かどうか
      return member.role_type === 'manager'
    },
  },
  mutations: {
  },
  actions: {
  },
}